import { put, takeEvery } from "redux-saga/effects";
import ProgramEvents from "./ProgramEvents";
import ProgramApi from "./ProgramApi";
import { Program, ProgramDetail} from "./model/Program";
import { 
    GetAllProgram,
    GetAllProgramComplete, 
    GetLearningProgram,
    GetLearningProgramComplete, 
    AddVideoToProgram, 
    UpdateProgram, 
    UpdateProgramComplete,
    UpdateProgramFailed,
    AddVideoToProgramComplete,
} from "./ProgramActions";

// 受講中プログラム取得
function* GetAllLearningProgramList({userId}: ReturnType<typeof GetLearningProgram>) {
    const listItem: Program[] = yield ProgramApi.GetLearningProgramList(userId);
    yield put(GetLearningProgramComplete(listItem));
}

// プログラムにエピソード・関連Videoを追加
function* AddVideoToProgramWorker({userId, programId, videoId, videoType}: ReturnType<typeof AddVideoToProgram>) {
    const program: any = yield ProgramApi.AddVideoToProgram(userId, programId, videoId, videoType);
    yield put(AddVideoToProgramComplete(program));   
}

// プログラム一覧取得
function* GetAllPrograms({userId}: ReturnType<typeof GetAllProgram>) {
    const listItem: ProgramDetail[] = yield ProgramApi.GetAllProgram(userId);
    yield put(GetAllProgramComplete(listItem));
}
// プログラム更新（管理画面用）
function* UpdateProgramWorker({userId, updateListItems, deleteListIdItems}: ReturnType<typeof UpdateProgram>) {
    const response = yield ProgramApi.UpdateProgram(userId, updateListItems, deleteListIdItems);
    if(response.response && response.response.status !== 200){
        yield put(UpdateProgramFailed(response.stack));
    }else{
        yield put(UpdateProgramComplete(response));
    }
}



export default function* ProgramSaga() {
    yield takeEvery(ProgramEvents.GetLearningProgramStarted, GetAllLearningProgramList);
    yield takeEvery(ProgramEvents.AddVideoToProgram, AddVideoToProgramWorker);
    yield takeEvery(ProgramEvents.GetAllProgramStarted, GetAllPrograms);
    yield takeEvery(ProgramEvents.UpdateProgramStarted, UpdateProgramWorker);

}
